import { TextKey } from '@mews-commander/enums';
import { lt } from '@mews/framework';
import { useCurrentEnterpriseId } from '@mews-commander/core';
import { ProfileFilterParameters, useRepositorySuspenseQuery, Profile } from '@mews-commander/data-access';
import { SelectField } from '@mews-commander/form';
import { createOption } from '@mews-commander/ui';
import { FilterValueKey } from '../constants';

export const OwnerProfile = () => {
    const mapProfileToOption = (s: Profile) => createOption({ value: s.id, label: s.name });
    const enterpriseId = useCurrentEnterpriseId();
    const { data } = useRepositorySuspenseQuery('enterpriseProfiles', 'getAll', {
        enterpriseId,
    } as ProfileFilterParameters);
    const { profiles } = data || {};
    const enterpriseProfiles =
        profiles?.filter((p) => 'enterpriseId' in p.data.value && p.data.value.enterpriseId === enterpriseId) || [];
    return (
        <SelectField
            label={lt(TextKey.Owner)}
            name={FilterValueKey.ownerProfileId}
            options={
                enterpriseProfiles.length
                    ? enterpriseProfiles
                          .toSorted((a, b) => a.name.localeCompare(b.name))
                          .map((s) => mapProfileToOption(s))
                    : []
            }
        />
    );
};
